import { Popconfirm, Space, Table } from "antd";
import { useContext } from "react";
import { UserContext } from "../../../context";
import history from "../../../routes/history";
import { placaMask } from "../../../utils";

const { Column } = Table;
export default function VeiculosTable({
  veiculos,
  loading,
  handleTableChange,
  total,
  confirm,
}) {
  function cancel(e) {
    console.log(e);
  }
  const user = useContext(UserContext);
  return (
    <div>
      <Table
        loading={loading}
        size="small"
        pagination={{ pageSize: 10, total }}
        onChange={handleTableChange}
        style={{ width: "100%" }}
        dataSource={veiculos}
        rowKey="id"
      >
        <Column title="Código" dataIndex="id" key="id" />

        <Column title="Descrição" dataIndex="descricao" key="descricao" />
        <Column title="Placa" dataIndex="placa" key="placa" render={(text) => placaMask(text)} />
        <Column title="Tipo" dataIndex="tipo" key="tipo" />
        <Column
          title="Ação"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <a onClick={() => history.push(`/veiculos/${record.id}`)}>
                Visualizar
              </a>

              {user?.type === "ADM" && (
                <Popconfirm
                  title="Deseja deletar o veiculo?"
                  onConfirm={() => confirm(record)}
                  onCancel={cancel}
                  okText="Sim"
                  cancelText="Não"
                >
                  <a>Deletar</a>
                </Popconfirm>
              )}
            </Space>
          )}
        />
      </Table>
    </div>
  );
}
